(() => {
  if (document.querySelector('.qrdesk-hero,.qrc-product') && window.Shopify?.theme?.id === 165745688611 && window.Shopify?.theme?.role === 'unpublished') {
    const contactLinks = document.querySelectorAll('[data-qrc-chat]');
    contactLinks.forEach(link => link.addEventListener('click', event => {
      if (typeof window.Zipchat?.open !== 'function') return;
      if (window.Zipchat.open({open:true}) === false) return;
      event.preventDefault();
    }));
    const quietChat = () => {
      const host = document.getElementById('zipchat-shadow-host');
      if (host?.shadowRoot && !host.shadowRoot.getElementById('qrc-quiet-chat')) {
        const style = document.createElement('style');
        style.id = 'qrc-quiet-chat';
        style.textContent = '#chat-preview-message{display:none!important}:host(:not([data-qrc-chat-open])) #widget-chat-container{display:none!important}';
        host.shadowRoot.appendChild(style);
      }
      const frame = document.getElementById('zipchat-iframe');
      if (host) host.toggleAttribute('data-qrc-chat-open', frame?.dataset.zipchatVisible === 'true');
      if (typeof window.Zipchat?._openWidget === 'function') contactLinks.forEach(link => { link.textContent = link.dataset.chatLabel; });
    };
    new MutationObserver(quietChat).observe(document.body, {childList:true});
    const frameObserver = new MutationObserver(quietChat);
    new MutationObserver(() => {
      const frame = document.getElementById('zipchat-iframe');
      if (frame && !frame.dataset.qrcObserved) {
        frame.dataset.qrcObserved = 'true';
        frameObserver.observe(frame, {attributes:true,attributeFilter:['data-zipchat-visible']});
      }
    }).observe(document.body, {childList:true});
    quietChat();
    let attempts = 0;
    const timer = setInterval(() => { quietChat(); if (++attempts >= 60) clearInterval(timer); }, 500);
  }
  const setup = root => {
    if (root.dataset.qrcReady) return;
    root.dataset.qrcReady = 'true';
    if (root.dataset.qrcWeekly !== 'true') return;
    const form = root.querySelector('form[action*="/cart/add"]');
    const status = root.querySelector('[data-qrc-plan-status]');
    if (!form || !status) return;
    let scheduled = false;
    const check = () => {
      scheduled = false;
      const field = form.querySelector('[name="selling_plan"]');
      const ready = !!field?.value && !field.disabled;
      root.dataset.qrcPlanReady = String(ready);
      form.querySelectorAll('button[type="submit"]').forEach(button => {
        if (!ready) {
          if (!button.disabled) { button.dataset.qrcPlanLocked = 'true'; button.disabled = true; }
        } else if (button.dataset.qrcPlanLocked && root.dataset.qrcAvailable === 'true') {
          delete button.dataset.qrcPlanLocked;
          button.disabled = false;
        }
      });
      if (ready && status.dataset.readyState !== 'true') {
        status.dataset.readyState = 'true';
        status.textContent = status.dataset.ready;
      }
    };
    const schedule = () => { if (!scheduled) { scheduled = true; queueMicrotask(check); } };
    const observer = new MutationObserver(schedule);
    observer.observe(form, {childList:true,subtree:true,attributes:true,attributeFilter:['value','disabled','name']});
    form.addEventListener('change', schedule);
    form.addEventListener('submit', event => {
      const field = form.querySelector('[name="selling_plan"]');
      if (!field?.value || field.disabled) { event.preventDefault(); event.stopImmediatePropagation(); status.focus(); }
    }, true);
    status.tabIndex = -1;
    check();
    setTimeout(() => { if (root.isConnected && root.dataset.qrcPlanReady !== 'true') status.textContent = status.dataset.unavailable; }, 15000);
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) observer.disconnect(); });
  };
  document.querySelectorAll('[data-qrc-product]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-qrc-product]').forEach(setup));
})();
